// src/pages/ContactPage.tsx
import React from 'react';
import ContactForm from '../components/contact/ContactForm';

const ContactPage = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-center mb-12">Contact Us</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        <div>
          <h2 className="text-2xl font-bold mb-4">Get in Touch</h2>
          <p className="text-lg text-gray-700 mb-6">
            We'd love to hear from you. Please fill out the form and we'll get 
            back to you as soon as possible.
          </p>
          
          <div className="mb-6">
            <h3 className="font-bold mb-2">Email</h3>
            <p className="text-gray-700">	support@loaddrive.com</p>
          </div>
          
          <div className="mb-6">
            <h3 className="font-bold mb-2">Phone</h3>
            <p className="text-gray-700">(812) 647-0759</p>
          </div>
          
          <div>
            <h3 className="font-bold mb-2">Address</h3>
           <p className="text-gray-700">
              8063 Madison Ave<br />
              #1050<br />
              Indianapolis, IN 46227
            </p>
          </div>
        </div>
        
        <div>
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
